module.exports = __webpack_public_path__ + "DINNextLTPro-LightItalic.woff?f8ddf1bdbe42e3169f221cf6ed29eaeb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-LightItalic.woff
// module id = 1431
// module chunks = 0